/**
 * Given a string, it hashes it and returns the first 8 characters
 * @param {string} value - The text to slugify.
 * @returns {string} - The hashed text.
 */
export default function hashString(value) {
  return new Promise((resolve) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashDigest = crypto.subtle.digest('SHA-1', data);
    hashDigest.then((val) => {
      const hex = [...new Uint8Array(val)]
        .map((x) => x.toString(16).padStart(2, '0')).join('');
      resolve(hex.substring(0, 8));
    });
  });
}



// WEBPACK FOOTER //
// ./app/utils/string/hashString.js